import EcoSectionCard from 'eco-design/sections/eco-section-card';
import useVideo from '../useVideo';
import styles from './index.module.scss';
import { useLang } from '@/i18n';

export default function Comp() {
    const { t } = useLang('theProduct.SectionC2');
    const { src } = useVideo({
        className: styles.comp,
        url: 'https://websiteoss.ecoflow.com/upload/video/1744766368337/video3.mp4',
        offset: '80%',
        duration: '200%',
    });
    return (
        <>
            <div className={styles.comp} id="sectionC2">
                <EcoSectionCard
                    theme="black"
                    layout="center-left"
                    isVideo={true}
                    label={t('label')}
                    title={t('title')}
                    desc={t('desc')}
                    poster='https://websiteoss.ecoflow.com/upload/image/1744874331407/video3.jpg'
                    pc={src}
                    autoPlay={false}
                />
            </div>
        </>
    );
}
